import React, { useState } from "react";
import WishSimpleCard from "../../../components/WishSimpleCard";

const DistCounts = ({ downlineCount }) => {
  // Calculate total distributors
  console.log(downlineCount, "downlineCount");
  const totalDistributors = downlineCount?.firstOrg?.totalCount + downlineCount?.secondOrg?.totalCount;

  // Calculate percentage of first vs second org
  const firstOrgPercentage =
    totalDistributors > 0 ? Math.round((downlineCount?.firstOrg?.totalCount / totalDistributors) * 100) : 0;
  const secondOrgPercentage =
    totalDistributors > 0 ? Math.round((downlineCount?.secondOrg?.totalCount / totalDistributors) * 100) : 0;

  // Helper function to calculate percentages within an organization
  const calculatePercentages = (org) => {
    const total = org?.totalCount || 0;
    return {
      active: total > 0 ? (((org?.activeCount || 0) / total) * 100).toFixed(1) : 0,
      inactive: total > 0 ? (((org?.inactiveCount || 0) / total) * 100).toFixed(1) : 0,
      others: total > 0 ? (((org?.othersCount || 0) / total) * 100).toFixed(1) : 0,
    };
  };

  const firstOrgPercentages = calculatePercentages(downlineCount?.firstOrg);
  const secondOrgPercentages = calculatePercentages(downlineCount?.secondOrg);

  return (
    <WishSimpleCard>
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="fs-4 fw-bold m-0">Network Performance Overview</h4>
            <p className="text-muted mb-0">Total Star And Above Ranked Direct Sellers</p>
          </div>
          <div className="text-end">
            <h2 className="fw-bold text-purple mb-1 " style={{ color: "#6f42c1", fontSize: "2.5rem" }}>
              {totalDistributors.toLocaleString()}
            </h2>
          </div>
        </div>
      </div>

      {/* Organization Cards */}
      <div className="row g-4">
        {/* First Org Card */}
        <div className="col-md-6">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h5 className="mb-0 fw-bold">
                  First Organization <span className="text-muted text-small">({firstOrgPercentage}% Share)</span>
                </h5>
                <h3 className="fw-bold mb-1" style={{ fontSize: "2rem" }}>
                  {downlineCount?.firstOrg?.totalCount.toLocaleString()}
                </h3>
              </div>

              {/* Status breakdown with labels */}
              <div className="mb-1">
                <div className="d-flex justify-content-between text-sm mb-2">
                  <span className="fw-medium">
                    <span className="text-success">Active:</span>{" "}
                    {downlineCount?.firstOrg?.activeCount.toLocaleString()}
                  </span>
                  <span className="fw-medium">
                    <span className="text-danger">Inactive:</span>{" "}
                    {downlineCount?.firstOrg?.inactiveCount.toLocaleString()}
                  </span>
                  <span className="fw-medium">
                    <span className="text-muted">Others:</span> {downlineCount?.firstOrg?.othersCount.toLocaleString()}
                  </span>
                </div>

                <div className="d-flex justify-content-between text-sm mb-2" style={{ fontSize: "0.85rem" }}>
                  <span>{firstOrgPercentages.active}%</span>
                  <span>{firstOrgPercentages.inactive}%</span>
                  <span>{firstOrgPercentages.others}%</span>
                </div>

                {/* Multi-segment progress bar */}
                <div className="progress" style={{ height: "12px", borderRadius: "6px" }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${firstOrgPercentages.active}%`, backgroundColor: "#28a745" }}
                    aria-valuenow={firstOrgPercentages.active}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${firstOrgPercentages.inactive}%`, backgroundColor: "#dc3545" }}
                    aria-valuenow={firstOrgPercentages.inactive}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${firstOrgPercentages.others}%`, backgroundColor: "#6c757d" }}
                    aria-valuenow={firstOrgPercentages.others}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Second Org Card */}
        <div className="col-md-6">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h5 className="mb-0 fw-bold">
                  Second Organization <span className="text-muted text-small">({secondOrgPercentage}% Share)</span>
                </h5>
                <h3 className="fw-bold mb-1" style={{ fontSize: "2rem" }}>
                  {downlineCount?.secondOrg?.totalCount.toLocaleString()}
                </h3>{" "}
              </div>

              {/* Status breakdown with labels */}
              <div className="mb-1">
                <div className="d-flex justify-content-between text-sm mb-2">
                  <span className="fw-medium">
                    <span className="text-success">Active:</span>{" "}
                    {downlineCount?.secondOrg?.activeCount.toLocaleString()}
                  </span>
                  <span className="fw-medium">
                    <span className="text-danger">Inactive:</span>{" "}
                    {downlineCount?.secondOrg?.inactiveCount.toLocaleString()}
                  </span>
                  <span className="fw-medium">
                    <span className="text-muted">Others:</span> {downlineCount?.secondOrg?.othersCount.toLocaleString()}
                  </span>
                </div>

                <div className="d-flex justify-content-between text-sm mb-2" style={{ fontSize: "0.85rem" }}>
                  <span>{secondOrgPercentages.active}%</span>
                  <span>{secondOrgPercentages.inactive}%</span>
                  <span>{secondOrgPercentages.others}%</span>
                </div>

                {/* Multi-segment progress bar */}
                <div className="progress" style={{ height: "12px", borderRadius: "6px" }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${secondOrgPercentages.active}%`, backgroundColor: "#28a745" }}
                    aria-valuenow={secondOrgPercentages.active}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${secondOrgPercentages.inactive}%`, backgroundColor: "#dc3545" }}
                    aria-valuenow={secondOrgPercentages.inactive}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${secondOrgPercentages.others}%`, backgroundColor: "#6c757d" }}
                    aria-valuenow={secondOrgPercentages.others}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-muted mt-4 text-end small">Last updated: {new Date().toLocaleTimeString()}</div>
    </WishSimpleCard>
  );
};

export default DistCounts;
